<template>
  <Table
    ref="table"
    :layers-filters="layersFilters"
    :is-custom-layer="true"
    :custom-layer-data="customLayerData"
    @setLayerFeaturesFilters="setLayerFeaturesFilters"
    @deleteLayerFeaturesFilters="deleteLayerFeaturesFilters"
  >
  </Table>
</template>

<script>
import { get, sync } from 'vuex-pathify';

import Table from '@/components/Table';

export default {
  name: 'TableInvestments',
  components: {
    Table,
  },
  computed: {
    activeTool: sync('tools/activeTool'),
    layerId: get('admin/modulesMapping@investments.layer_id'),
    layersFilters: get('layers/layersFilters'),
    customLayerData() {
      return {
        routeName: 'investment',
        eventName: 'toggleInvestments',
        filterEventName: 'toggleInvestmentsFilter',
        layerId: this.layerId,
      };
    },
  },
  methods: {
    deleteLayerFeaturesFilters(currentLayerId) {
      this.$store.set('layers/DELETE_LAYERS_FILTERS!', currentLayerId);
    },
    setLayerFeaturesFilters(filter) {
      this.$store.set('layers/SET_LAYERS_FILTERS!', filter);
    },
  },
  beforeCreate() {
    this.$once('hook:beforeDestroy', () => {
      this.$nextTick(() => {
        this.activeTool = undefined;
      });
      this.$root.$emit('toggleInvestments', false);
    });
  },
};
</script>

<style scoped></style>
